// Do NOT add "use client" to this file
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { localNum } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var ImageOverlay = function(param) {
    var extraProductsCount = param.extraProductsCount, smallCount = param.smallCount;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: extraProductsCount ? /*#__PURE__*/ _jsx(Column, {
            align: "center",
            justify: "center",
            className: "bg-core-surface-default/50 p-2x absolute bottom-0 left-0 right-0 top-0",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: smallCount ? "paragraphSansMedium" : "sectionHeaderSansMedium",
                color: Core.text.inverse,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "IlbPF7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "+"
                        },
                        {
                            type: 1,
                            value: "countNumber"
                        }
                    ],
                    values: {
                        countNumber: localNum(extraProductsCount)
                    }
                })
            })
        }) : /*#__PURE__*/ _jsx("div", {
            className: "pointer-events-none absolute left-0 top-0 z-2 h-full w-full",
            style: {
                background: "".concat(Core.surface.enabled, "05")
            }
        })
    });
};
